export const CSAT_SAMPLE_RATE_MIN = 0;
export const CSAT_SAMPLE_RATE_MAX = 100;

/** Survey every eligible conversation, matching behaviour before sampling existed. */
export const CSAT_SAMPLE_RATE_DEFAULT = CSAT_SAMPLE_RATE_MAX;

/** Distinguishes bucketing purposes so two decisions never correlate on the same id. */
export const CSAT_SAMPLE_SALT = "csat-sample";

/** FNV-1a — stable across processes, deploys, Node and the browser, and dependency-free. */
function fnv1a(value: string): number {
  let hash = 0x81_1c_9d_c5;
  for (let index = 0; index < value.length; index++) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 0x01_00_01_93);
  }
  return hash >>> 0;
}

/** Deterministic bucket for an id, so retries and rescans reach the same verdict. */
export function stableBucket(id: string, salt: string, buckets = 100): number {
  return fnv1a(`${salt}:${id}`) % buckets;
}

export function normalizeCsatSampleRate(
  rate: number | null | undefined,
): number {
  if (rate == null || !Number.isFinite(rate)) {
    return CSAT_SAMPLE_RATE_DEFAULT;
  }
  return Math.min(
    CSAT_SAMPLE_RATE_MAX,
    Math.max(CSAT_SAMPLE_RATE_MIN, Math.round(rate)),
  );
}

/** Whether this conversation falls in the sampled share that gets a survey. */
export function isInCsatSample(
  conversationId: string,
  rate: number | null | undefined,
): boolean {
  return (
    stableBucket(conversationId, CSAT_SAMPLE_SALT) <
    normalizeCsatSampleRate(rate)
  );
}
